import { NavigationGuardNext, Route } from 'vue-router'
import MarketplaceRoot from './components/MarketplaceRoot.vue'
import { trackEvent, SEGMENT_EVENTS } from '@/analytics/segment'

function hasQueryParameters(route: Route) {
  return Object.keys(route.query).length > 0
}

export default [
  {
    path: 'marketplace',
    beforeEnter(to: Route, from: Route, next: NavigationGuardNext) {
      if (hasQueryParameters(to)) {
        trackEvent(SEGMENT_EVENTS.MARKETPLACE_SEARCHING_FOR_OFFERS_QUERY, to.query)
      }
      return next()
    },
    component: MarketplaceRoot
  }
]
